// EXEC DayTypesAllowTourScheduling 'true',1563,null,25,'true',1

const dayTypes = [
  {
    id: 25,
    name: 'Regular Work Day',
    abbr: 'REG',
    sortOrder: 1,
    allowTourScheduling: true
  },
  {
    id: 1,
    name: 'Overtime Day(6d, 7d)',
    abbr: 'OT',
    sortOrder: 2,
    allowTourScheduling: true
  },
  {
    id: 180,
    name: 'Comp Day Earned',
    abbr: 'CMPE',
    sortOrder: 15,
    allowTourScheduling: true
  },
  {
    id: 18,
    name: 'Remote Asn (OT)',
    abbr: 'RMO',
    sortOrder: 20,
    allowTourScheduling: true
  },
  {
    id: 19,
    name: 'Remote Asn (ST)',
    abbr: 'RM',
    sortOrder: 20,
    allowTourScheduling: true
  },
  {
    id: 38,
    name: 'B Credit',
    abbr: 'B',
    sortOrder: 22,
    allowTourScheduling: true
  },
  {
    id: 177,
    name: 'REG/HOL',
    abbr: 'Reg/H',
    sortOrder: 87,
    allowTourScheduling: true
  },
  {
    id: 113,
    name: 'REG/VAC',
    abbr: 'REG/V',
    sortOrder: 87,
    allowTourScheduling: true
  },
  {
    id: 133,
    name: 'REG/PBACK',
    abbr: 'REG/P',
    sortOrder: 88,
    allowTourScheduling: true
  },
  {
    id: 55,
    name: '1/2 Payback Day',
    abbr: 'PB.5',
    sortOrder: 103,
    allowTourScheduling: true
  },
  {
    id: 56,
    name: '1/2 Personal Day',
    abbr: 'PP.5',
    sortOrder: 103,
    allowTourScheduling: true
  },
  {
    id: 57,
    name: '1/2 ILL Day',
    abbr: 'I.5',
    sortOrder: 104,
    allowTourScheduling: true
  },
  {
    id: 48,
    name: '1/2 Vacation Day',
    abbr: 'V.5',
    sortOrder: 105,
    allowTourScheduling: true
  },
  {
    id: 185,
    name: "1/2 Last Year's Vacation Day",
    abbr: 'LVD.5',
    sortOrder: 106,
    allowTourScheduling: true
  },
  {
    id: 130,
    name: 'Holiday Worked (Mgmt only)',
    abbr: 'HW',
    sortOrder: 880,
    allowTourScheduling: true
  },
  {
    id: 94,
    name: 'AVAILABLE - TELEMUNDO ONLY',
    abbr: 'AVT',
    sortOrder: 8000,
    allowTourScheduling: true
  },
  {
    id: 166,
    name: 'WVIT Personal Holiday AFTRA',
    abbr: 'FLHOL',
    sortOrder: 88880,
    allowTourScheduling: true
  }

];

export default dayTypes;

